import type { KanbanColumnState, StatusId } from '../store/kanban.types'

export const KANBAN_DEFAULT_COLUMN_ITEMS_LIMIT = 7
export const KANBAN_BOARD_MAX_COLUMN_LIMIT = 100

/** Лимиты карточек по статусам для GET board (учитывает догрузку infinite scroll). */
export function buildKanbanStatusLimitsFromColumns(
  columnsByStatusId: Record<StatusId, KanbanColumnState>,
  defaultLimit = KANBAN_DEFAULT_COLUMN_ITEMS_LIMIT,
): Record<StatusId, number> {
  const statusLimits: Record<StatusId, number> = {}

  for (const [statusIdStr, column] of Object.entries(columnsByStatusId)) {
    const statusId = Number(statusIdStr)
    if (!Number.isFinite(statusId) || statusId <= 0) continue

    const loadedCount = column.ids.length
    statusLimits[statusId] = Math.min(
      KANBAN_BOARD_MAX_COLUMN_LIMIT,
      Math.max(loadedCount, defaultLimit),
    )
  }

  return statusLimits
}
